import { LogLevel } from 'src/app/core/logging/log-level';
import { Logger } from 'src/app/core/logging/logger';

export class ConsoleLogger extends Logger {
    protected override log(level: LogLevel, message: unknown, additional: unknown[] = []): void {
        switch (level) {
            case LogLevel.DEBUG:
                console.debug(message, ...additional);
                break;
            case LogLevel.INFO:
                console.info(message, ...additional);
                break;
            case LogLevel.WARN:
                console.warn(message, ...additional);
                break;
            case LogLevel.ERROR:
                console.error(message, ...additional);
                break;
        }
    }
}
